var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBulb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.346,
    height: 82,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.346 27.774C58.346 12.418 44.528 0 29.173 0S0 12.438 0 27.774c0 6.111 2.6 11.058 5.953 15.789h-.059c2.149 2.957 4.218 3.489 6.209 6.9 2.9 4.967 3.568 8.023 3.686 10.979a3.162 3.162 0 0 0 3.154 3.016H20.7a.791.791 0 0 0 .788-.788V45.041a6.376 6.376 0 0 0-.67-2.819l-4.139-8.279a2.067 2.067 0 1 1 3.706-1.833l4.987 10.132a6.191 6.191 0 0 1 .65 2.779v18.647a.791.791 0 0 0 .788.788h4.731a.791.791 0 0 0 .788-.788V45.021a6.19 6.19 0 0 1 .65-2.779l5.007-10.171a1.983 1.983 0 1 1 3.548 1.774l-4.2 8.4a6.44 6.44 0 0 0-.67 2.819v18.608a.791.791 0 0 0 .788.788h1.971a3.153 3.153 0 0 0 3.154-2.957c.177-3.036.926-6.367 3.627-11.038 1.991-3.41 4.061-3.942 6.209-6.9h-.02c3.351-4.733 5.953-9.681 5.953-15.791zM25.625 82h7.1a2.76 2.76 0 0 0 0-5.519h-7.1a2.76 2.76 0 0 0 0 5.519zm-3.942-8.673h14.981a2.76 2.76 0 0 0 0-5.519H21.683a2.76 2.76 0 1 0 0 5.519z",
    fill: "#ffba60"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.259a2e4ef2ea29fc662a83a5778ef1a7.svg";
export { ForwardRef as ReactComponent };